module.exports = __webpack_public_path__ + "static/media/weather-app.cf28834b.png";